import './ItineraryCoverHeader.css';
import React from 'react';
import { get, getDictionaryItem, canUseDOM, getPageThemeColors, getColorByTheme } from '../../utils';
import ComponentsWrapper from '../atoms/ComponentsWrapper';
import CuratorPicks from '../atoms/CuratorPicks/CuratorPicks';
import { SitecoreContextReactContext } from '../../utils/SitecoreContextReactContext';
import { fullWidthStyles } from '../57_HeaderFullWidth/headerFullWidth';
import { Text, RichText, Placeholder } from '@sitecore-jss/sitecore-jss-react';
import Video from '../atoms/Video';
import { headerImageStyle } from '../57_HeaderArticle1/HeaderArticle1';
import FavouriteBtn from '../atoms/FavouriteBtn/FavouriteBtn';
import { tealiumClickFunc, tealiumMergeClickData } from '../../utils/tealium';
import DarkThemeControl from '../BrightcoveVideosAtoms/DarkThemeControl';
const videoWhiteOverlayTime = 750;
const videoFadeTime = 400;
export const ItineraryCoverHeader = _ref => {
  let {
    fields,
    rendering,
    children,
    params
  } = _ref;
  const sitecoreContext = React.useContext(SitecoreContextReactContext);
  const isSharedCh = get(params, 'RenderingStyle') === 'Shared Channels' || false;
  const rtl = Boolean(sitecoreContext && sitecoreContext.rtl);
  const days = get(fields, 'data.item.days') || [];
  const moduleId = get(fields, 'data.item.id');
  const rawCurators = get(fields, 'data.item.curators.jss.value');
  const curators = rawCurators ? JSON.parse(rawCurators) : '';
  const dictionary = get(fields, 'data.dictionary');
  const CuratorsPick = getDictionaryItem(dictionary, 'CuratorsPick');
  const darkModeTitle = getDictionaryItem(dictionary, "dark mode") || '';
  //const pois = get(fields, 'data.item.pois.values') || [];
  const title = get(fields, 'data.item.title.jss');
  const introText = get(fields, 'data.item.introText.jss');
  const name = get(fields, 'data.item.name');
  let placeNumber = 0;
  const {
    addToFavAnalytics,
    smallBannerClickAnalytics
  } = fields.data;
  days.map(item => {
    const length = get(item, 'pois.values.length');
    placeNumber += length;
  });
  placeNumber = placeNumber || get(fields, 'data.item.pois.values.length');
  const countDays = days.length;
  const hasCategory = Boolean(get(fields, 'data.item.category.targetItem.title.jss.value'));
  const category = get(fields, 'data.item.category.targetItem.title.jss');
  const hasIntroText = Boolean(introText);
  const hasTitle = Boolean(title);
  const BASE_URL = String(process.env.REACT_APP_MEDIA_HOST || '');
  const dictionaryValues = get(fields, 'data.dictionary.dictionaryValues');
  const dayPhrase = dictionaryValues ? get(dictionaryValues[2], 'phrase.jss.value') : '';
  const placesPhrase = dictionaryValues ? get(dictionaryValues[3], 'phrase.jss') : '';
  const pageEditing = Boolean(sitecoreContext && sitecoreContext.pageEditing);
  const [isVdsite, setIsVdsite] = React.useState(true);
  const darkMode = get(sitecoreContext, 'darkMode');
  const actions = get(sitecoreContext, 'actions', {});
  const {
    changeThemeFunction = () => {}
  } = actions;
  React.useEffect(() => {
    if (canUseDOM && !document.body.classList.contains('vdsite')) {
      setIsVdsite(false);
    }
  }, []);
  const primaryPageThemeColor = get(sitecoreContext, 'themesOfPage.primary');
  const primaryActivePageThemeColor = get(sitecoreContext, 'themesOfPage.primary_active');
  const BackgroundColorHex = get(params, 'BackgroundColorHex');
  const ActiveColorHex = get(params, 'ActiveColorHex');
  const ColorHex = get(params, 'ColorHex');
  const primaryColor = primaryPageThemeColor ? primaryPageThemeColor : getPageThemeColors(isVdsite).primary;
  const primaryColorActive = primaryActivePageThemeColor ? primaryActivePageThemeColor : getPageThemeColors(isVdsite).primary_active;
  const variables = BackgroundColorHex ? {
    '--m57-itinerary-cover-header-primary-color': BackgroundColorHex,
    '--m57-itinerary-cover-header-active-primary-color': ActiveColorHex,
    '--m57-itinerary-cover-header-color': ColorHex
  } : {
    '--m57-itinerary-cover-header-primary-color': primaryColor,
    '--m57-itinerary-cover-header-active-primary-color': primaryColorActive,
    '--m57-itinerary-cover-header-color': getColorByTheme(primaryPageThemeColor)
  };
  const renderMediaPlaceholder = () => {
    return /*#__PURE__*/React.createElement(Placeholder, {
      name: "media-header-general",
      rendering: rendering,
      mediaDesc: introText.value
    });
  };
  return /*#__PURE__*/React.createElement(StyledWrapper, {
    rtl: rtl,
    anchorUrlParameter: params['Anchor Url Parameter'],
    isSharedCh: isSharedCh
  }, params && params['Dark Mode Switcher Show'] && /*#__PURE__*/React.createElement(DarkThemeControl, {
    handleClick: changeThemeFunction,
    label: darkModeTitle,
    value: darkMode,
    params: params
  }), /*#__PURE__*/React.createElement("div", {
    className: "container",
    style: variables
  }, /*#__PURE__*/React.createElement("div", {
    className: "module-group remove-padding-header"
  }, /*#__PURE__*/React.createElement("div", {
    className: "module"
  }, /*#__PURE__*/React.createElement("div", {
    className: "row"
  }, /*#__PURE__*/React.createElement("div", {
    className: "col"
  }, /*#__PURE__*/React.createElement("div", {
    "data-animation-breakpoint": "768",
    className: "header-animation-breakpoint header__poi header__full-width-mob js-header-bm-parent"
  }, /*#__PURE__*/React.createElement("div", {
    className: `header-bb__wrapper header-bb__wrapper--poster-show ${isSharedCh ? 'fav-btn-box--shared' : ''}`
  }, process.env.STORYBOOK_MODE ? children : renderMediaPlaceholder(), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: 'my-icon-white header__fav-btn',
    componentPrimaryColor: BackgroundColorHex,
    componentPrimaryColorActive: ActiveColorHex,
    analyticsClick: action => tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${action} : ${name}`)
  })), /*#__PURE__*/React.createElement("div", {
    className: `header-bb__info js-header-bm header-animation__content`
  }, /*#__PURE__*/React.createElement("div", {
    className: `header-animate__content-bg`
  }), /*#__PURE__*/React.createElement(CuratorPicks, {
    copy: CuratorsPick,
    curators: curators.curators,
    analytics: {
      smallBannerClickAnalytics,
      params,
      name
    }
  }), /*#__PURE__*/React.createElement("div", {
    className: "header__type-tag"
  }, hasCategory && /*#__PURE__*/React.createElement(Text, {
    field: category
  })), hasTitle ? /*#__PURE__*/React.createElement("h1", {
    className: "header__info-title"
  }, /*#__PURE__*/React.createElement(Text, {
    field: title
  })) : '', /*#__PURE__*/React.createElement("div", {
    className: "header__icons"
  }, placeNumber > 0 && /*#__PURE__*/React.createElement("div", {
    className: "details-icon__image"
  }, /*#__PURE__*/React.createElement("p", {
    className: "details-text"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "details-icon__img",
    width: "17",
    height: "21",
    viewBox: "0 0 17 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M8.639 1.01349C6.68405 1.00075 4.79939 1.74184 3.37673 3.08275C1.95407 4.42365 1.10285 6.2612 1 8.21348V8.25148C1.125 12.6175 4.95 16.6445 8.335 20.0065C8.47871 20.1441 8.67098 20.2193 8.86991 20.2157C9.06884 20.2122 9.25829 20.1301 9.397 19.9875C12.529 16.6155 16.672 12.9615 16.592 8.04448C16.4577 6.06167 15.5475 4.21163 14.0587 2.8952C12.5699 1.57877 10.6223 0.901987 8.638 1.01149L8.639 1.01349ZM8.665 2.31349C10.2919 2.21663 11.8907 2.76894 13.111 3.8493C14.3312 4.92966 15.0731 6.44985 15.174 8.07647C15.239 12.0495 11.909 15.3025 8.856 18.5415C5.68799 15.3415 2.53599 11.6995 2.42599 8.24148C2.4904 6.63626 3.17757 5.11925 4.34175 4.01219C5.50593 2.90513 7.05556 2.2951 8.66199 2.31147L8.665 2.31349Z",
    fill: "#57585C",
    stroke: "#57585C",
    "stroke-width": "0.5"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M8.99609 10.5156C10.1007 10.5156 10.9961 9.62019 10.9961 8.51562C10.9961 7.41106 10.1007 6.51562 8.99609 6.51562C7.89152 6.51562 6.99609 7.41106 6.99609 8.51562C6.99609 9.62019 7.89152 10.5156 8.99609 10.5156Z",
    fill: "#57585C"
  })), placeNumber, " ", /*#__PURE__*/React.createElement(Text, {
    field: placesPhrase
  }))), countDays > 0 && /*#__PURE__*/React.createElement("div", {
    className: "details-icon__image"
  }, /*#__PURE__*/React.createElement("p", {
    className: "details-text"
  }, /*#__PURE__*/React.createElement("svg", {
    className: "details-icon__img",
    width: "20",
    height: "20",
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M10 4V10H14.5M19 10C19 14.9706 14.9706 19 10 19C5.02944 19 1 14.9706 1 10C1 5.02944 5.02944 1 10 1C14.9706 1 19 5.02944 19 10Z",
    stroke: "#57585C",
    "stroke-width": "1.5",
    "stroke-linecap": "round",
    "stroke-linejoin": "round"
  })), /*#__PURE__*/React.createElement("span", null, dayPhrase && countDays > 0 && dayPhrase.replace('{day}', countDays))))), /*#__PURE__*/React.createElement("div", {
    className: "header__content-p"
  }, hasIntroText && /*#__PURE__*/React.createElement(RichText, {
    field: introText
  })), /*#__PURE__*/React.createElement(FavouriteBtn, {
    itemId: moduleId,
    classes: 'my-icon-white header__fav-btn',
    componentPrimaryColor: BackgroundColorHex,
    componentPrimaryColorActive: ActiveColorHex,
    analyticsClick: action => tealiumClickFunc(tealiumMergeClickData(addToFavAnalytics, params), `${action} : ${name}`)
  })))))))));
};
const StyledWrapper = _ref2 => {
  let {
    children,
    rtl,
    anchorUrlParameter,
    isSharedCh
  } = _ref2;
  return /*#__PURE__*/React.createElement(ComponentsWrapper, {
    anchorUrlParameter: anchorUrlParameter,
    className: `header-animation    ${isSharedCh ? 'shared-styles' : ''} 
      ${commonStyles} ${fullWidthStyles} ${rtl ? rtlStyles : ltrStyles} ${headerImageStyle}`
  }, children);
};
const commonStyles = "ceqehn";
const ltrStyles = "l1trs4xa";
const rtlStyles = "r1ohf2g6";
export default ItineraryCoverHeader;